<template>
    <fluke-login-box title="Entrar">
        <div slot="content">
            <div class="check" v-if="checkFails">A combinação <b>Usuário / Senha</b> é invalida!</div>
            <div class="check" v-if="serverFails">Falha no serviço, tente mais tarde.</div>

            <div class="box-input">
                andre.pinto@mariawl.com
                <label for="usuario">Usuário:</label>
                <input
                    id="usuario"
                    type="text"
                    v-model="user"
                    v-on:keyup.enter="login" /><br>
            </div>
            <div class="box-input">
                #Fluke@2019!
                <label for="senha">Senha:</label>
                <input
                    id="senha"
                    type="password"
                    v-model="password"
                    v-on:keyup.enter="login" /><br>
            </div>

            <button v-on:click="login">ENTRAR</button>
        </div>
        <div slot="links">
            <router-link to="/recuperar-senha">
                Esqueci minha senha
            </router-link>
        </div>
    </fluke-login-box>
</template>

<script>
import axios from 'axios'
import LoginBox from '../components/Main/Content/LoginBox/LoginBox'

export default {
    components: {
        'fluke-login-box': LoginBox,
    },
    data () {
        return {
            user: '',
            password: '',
            checkFails: false,
            serverFails: false
        }
    },
    mounted: function() {
        var token = this.$cookies.get('token')
        if ( token ) {
            if ( this.$store.state.loggingOut ) {
                // logging out ...
                this.$cookies.remove('token');
                this.$cookies.remove('userId');
                this.$cookies.remove('tokenExpiration');
            }
            else {
                this.$router.push( '/' );
                return;
            }
        }
        this.$store.state.loggedIn = false;
    },
    methods: {
        async login()
        {
            var response = '';
            try {
                response = await axios.post(
                    this.$myServerAddresses.admin + 'login',
                    {
                        user: this.user,
                        password: this.password
                    }
                )
                if ( response.data.token == false) {
                    this.checkFails = true;
                    return;
                }
            } catch(e) {
                this.serverFails = true;
                console.log(e);
                return;
            }

            this.$store.state.loggedIn = true;
            this.$cookies.set( 'token', response.data.token, "1h" );
            this.$cookies.set( 'userId', response.data.userId, "1h" );
            this.$cookies.set( 'tokenExpiration', response.data.tokenExpiration, "1h" );
            this.$cookies.set( 'permission', response.data.permission, "1h" );

            if( response.data.reset == 1 ){
                this.$store.commit(
                    'flash_warning',
                    'Por favor, altere sua senha!'
                );
                this.$router.push({
                    name: 'users-reset',
                    params: {
                        id: response.data.userId,
                        reset: true
                    }
                });
            } else if( this.$store.state.nextUrl != null ) {
                this.$router.push( this.$store.state.nextUrl );
            } else {
                this.$router.push( '/' );
            }
        }
    }
}
</script>
